import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Form, Input, Label, Button } from '@/shared/components';
import { motLookupSchema, type MotLookupFormInputs } from '../schemas/motLookup.schema';

interface MotLookupFormProps {
  onSubmit: (data: MotLookupFormInputs) => void;
  isLoading?: boolean;
  defaultValues?: Partial<MotLookupFormInputs>;
}

export const MotLookupForm: React.FC<MotLookupFormProps> = ({ onSubmit, isLoading = false, defaultValues }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<MotLookupFormInputs>({
    resolver: zodResolver(motLookupSchema),
    defaultValues,
  });

  return (
    <Form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div>
        <Label htmlFor="vrm">Registration (VRM)</Label>
        <Controller
          name="vrm"
          control={control}
          render={({ field }) => (
            <Input
              id="vrm"
              type="text"
              placeholder="e.g. AB12CDE"
              error={!!errors.vrm}
              hint={errors.vrm?.message !== 'Enter a VIN or VRM' ? errors.vrm?.message : undefined}
              value={field.value ?? ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
          )}
        />
      </div>
      <div>
        <Label htmlFor="vin">or VIN</Label>
        <Controller
          name="vin"
          control={control}
          render={({ field }) => (
            <Input
              id="vin"
              type="text"
              placeholder="17-character VIN"
              error={!!errors.vin}
              hint={errors.vin?.message}
              value={field.value ?? ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
          )}
        />
      </div>
      {errors.vrm?.message === 'Enter a VIN or VRM' && (
        <p className="text-sm text-mp-error">{errors.vrm.message}</p>
      )}
      <Button type="submit" disabled={isLoading} className="w-full">
        {isLoading ? 'Looking up…' : 'Look up MOT History'}
      </Button>
    </Form>
  );
};
